import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWikimediacommonsComponent } from './simple-icons-wikimediacommons.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWikimediacommonsComponent ],
    exports:      [ SimpleIconsWikimediacommonsComponent ],
    bootstrap:    []
})
export class SimpleIconsWikimediacommonsModule {}
